import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
  },
})



// WEBPACK FOOTER //
// ./src/components/questions/follow_up/styles.js